import cloneDeep from 'lodash/cloneDeep'
import isArray from 'lodash/isArray'
import isPlainObject from 'lodash/isPlainObject'
import isEmpty from 'lodash/isEmpty'

// 判断是否为APP
const isInCoinsApp = (ua = '') => {
  if (!ua) return false
  return /getcoins/i.test(ua)
}

const isfail = (res) => {
  return (
    res.status === 'rejected' ||
    (isArray(res.value) && !res.value.length) ||
    (isPlainObject(res.value) && isEmpty(res.value))
  )
}
// 整合「context」参数
export const arrangeContext = (context) => {
  const { store, req, params, query, route } = context
  const { pathMatch = 'id' } = params
  const { state = {} } = store
  const { name = '' } = route
  const { source = 'ns', rendermode = 'ssr' } = query
  const reqUserAgent = req?.headers['user-agent'] || ''
  const ssrAllData = state.detail.ssrAllData || []

  const isCoinsApp = isInCoinsApp(reqUserAgent)

  const ssrLocationParams = {
    host: req?.headers.host,
    url: req?.url,
    health_checks: req?.headers?.['is-health-examination'] || '',
  }

  let game = ''

  if (name === 'hago') {
    game = 'hago'
  } else if (name === 'Detail2') {
    game = params?.gameName?.toLowerCase() || ''
  } else {
    game = query?.game?.toLowerCase() || ''
  }

  const parameter = {
    ssrLocationParams,
    country: pathMatch,
    game,
    source,
    rendermode,
    ssrAllData,
    store,
    isCoinsApp,
  }

  return Object.assign({}, parameter)
}

// 重试机制
export const RetryMechanism = async (promiseList, store, parames) => {
  let rejects = [] // SSR 重试
  let resolves = {} // SSR 成功
  let caches = [] // 缓存

  try {
    const promises = promiseList.map((req) => ({ ...req, parames }))

    // todo test
    // const _promises1 = promiseList.map((req) => ({ ...req, parames }))
    // let _promises2 = cloneDeep(_promises1)
    // let promises = _promises2.map((item) => {
    //   let _item = cloneDeep(item)
    //   if (_item.key == 'skulist') {
    //     _item.parames.game = '11111'
    //   }
    //   return _item
    // })

    const result = await Promise.allSettled(
      promises.map((pro) => pro.func(pro.parames))
    )

    // warn 重试机制
    result.forEach((res, index) => {
      const key = promises[index].key

      if (isfail(res)) {
        rejects.push({
          [key]: parames,
        })
      } else {
        resolves[key] = res.value
      }
    })
    const { cmsconfig = {}, skulist = [], basicConfig = {} } = resolves
    const allData = [cmsconfig, skulist, basicConfig]

    //! 成功的数据、存入
    store.commit('detail/setSsrAllData', allData)
    caches = cloneDeep(allData)
  } catch (error) {
    throw Error('重试机制报错~')
  }
  return {
    rejects,
    caches,
  }
}
